import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule, ListNavigationModule, SpinnerModule } from '@spartacus/storefront';
import { KnBrDirectiveModule } from 'src/app/shared/directive/kn-br-directive.module';
import { KnBrCustomPipesModule } from 'src/app/shared/pipe/kn-br-custom-pipes/kn-br-custom-pipes.module';
import { KnBrQuickOrderHistroyComponent } from './kn-br-quick-order-histroy.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        UrlModule,
        I18nModule,
        FormErrorsModule,
        NgbModule,
        SpinnerModule,
        ListNavigationModule,
        KnBrDirectiveModule,
        KnBrCustomPipesModule,
        ConfigModule.withConfig({
            cmsComponents: {
                KnBr360OrderHistoryComponent: {
                    component: () => import('./kn-br-quick-order-histroy.component').then((c) => c.KnBrQuickOrderHistroyComponent),
                },
            },
        } as CmsConfig),
        KnBrQuickOrderHistroyComponent,
    ],
})
export class KnBrQuickOrderHistroyModule {}
